import React from 'react';
import { connect } from 'react-redux';
import { Typography, Button } from '@material-ui/core';
import Formsy from 'formsy-react';
import TextInput from 'components/inputs/TextInput';
import LoginMenu from 'components/menus/LoginMenu';
import { push } from 'connected-react-router';
import { verifyUser } from 'actions/SessionActions';

export class MfaVerifyPage extends React.Component {
  constructor(props) {
    super(props);

    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    if (!this.props.verifyingUser) {
      this.props.navigateTo('login');
    }
  }

  handleSubmit(data, _data, _invalidateForm) {
    this.props.verifyUser(this.props.verifyingUser, data.verification_code);
  }

  render() {
    const { isProcessing } = this.props;

    return (
      <React.Fragment>
        <Typography variant="h4" align="center" className="top-space" gutterBottom>Multi Factor Authentication</Typography>

        <Typography variant="body1" className="top-space" gutterBottom>
          An email has been sent containing a verification code. Please enter it below to confirm your account
        </Typography>

        <Formsy onValidSubmit={this.handleSubmit}>
          <TextInput name="verification_code" label="Code" compact required
            validationErrors={{
              isDefaultRequiredValue: "can't be blank"
            }}
          />

          <div className="login-button-container">
            <Button type="submit" disabled={isProcessing} variant="contained" color="primary">Log In</Button>
            <LoginMenu />
          </div>
        </Formsy>
      </React.Fragment>
    );
  }
}

function mapStateToProps(state) {
  return {
    isProcessing: state.session.isProcessing,
    verifyingUser: state.session.verifyingUser
  }
}

const mapDispatchToProps = {
  verifyUser: (username, code) => verifyUser(username, code),
  navigateTo: (path) => push(path)
};

export default connect(mapStateToProps, mapDispatchToProps)(MfaVerifyPage)
